import RecordRTC from "recordrtc";
export default class SoundRecorder {
  audio?: HTMLAudioElement;
  recorder?: RecordRTC;
  recorderSteam?: MediaStream;
  recording = false;
  audioPlaying = false;
  isAuricularGyrus = false; // 是否有耳返
  gyrusAudio?: HTMLAudioElement;

  constructor(isAuricularGyrus?: boolean) {
    isAuricularGyrus && (this.isAuricularGyrus = isAuricularGyrus);
    if (this.isAuricularGyrus) {
      this.gyrusAudio = new Audio();
      this.gyrusAudio.autoplay = true;
    }
  }

  async startRecording() {
    if (!this.recorder) {
      await this.createRecorder();
    }
    this.recorder?.startRecording();
    this.recording = true;
  }

  async stopRecording() {
    return new Promise<void>((resolve) => {
      if (!this.recording || !this.recorder) {
        console.warn(" no recording now or no recorder");
        resolve();
        return;
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      this.recorder!.stopRecording(() => {
        this.recording = false;
        if (this.isAuricularGyrus) {
          this.gyrusAudio!.srcObject = null;
        }
        const dataUrl = URL.createObjectURL(this.recorder!.getBlob());
        if (!dataUrl) {
          console.log("dataUrl为空", dataUrl);
        }
        that.audio = new Audio(dataUrl);
        that.audio.src = "";
        setTimeout(() => {
          that.audio && (that.audio.src = dataUrl);
        }, 0);

        that.stopRecordAndStream();

        resolve();
      });
    });
  }

  async stopRecordAndStream() {
    if (this.recorderSteam) {
      this.recorderSteam.getTracks().forEach((track) => {
        track.stop();
      });
    }
    if (this.recorder) {
      this.recorder.destroy();
      this.recorder = undefined;
    }
  }

  async destroy() {
    if (!this.recorder) {
      console.warn(" no recording now or no recorder");
      return;
    }
    if (this.recorderSteam) {
      this.recorderSteam.getTracks().forEach((track) => {
        track.stop();
      });
    }
    this.audio = undefined;
    this.audioPlaying = false;
    this.recorder.destroy();
    this.recorder = undefined;
  }

  play(volume = 1) {
    if (!this.audio) {
      console.warn(" no audio");
      return;
    }
    this.audio.volume = volume;
    this.audio.onended = () => {
      this.audioPlaying = false;
    };
    this.audio.play();
    this.audioPlaying = true;
  }

  pause() {
    if (!this.audio) {
      console.warn(" no audio");
      return;
    }
    if (this.audio.paused) {
      console.warn(" audio is paused");
      return;
    }
    this.audio.pause();
    this.audioPlaying = false;
  }

  stop() {
    if (!this.audio) {
      console.warn(" no audio");
      return;
    }
    this.audio.currentTime = 0;
    this.audio.pause();
    this.audio.src = "";
    this.audio = undefined;
    this.audioPlaying = false;
  }

  getVolume() {
    if (!this.audio) {
      console.warn(" no audio");
      return 0;
    }
    return this.audio.volume;
  }

  setVolume(volume: number) {
    if (!this.audio) {
      console.warn(" no audio");
      return;
    }
    this.audio.volume = volume;
  }

  async createRecorder(): Promise<RecordRTC> {
    if (this.recorder) {
      return this.recorder;
    }

    const stream = await navigator.mediaDevices
      .getUserMedia({
        audio: {
          echoCancellation: true,
        },
      })
      .catch((e) => {
        console.error("No permission record", e);
      });
    this.recorderSteam = stream as MediaStream;
    if (this.isAuricularGyrus) {
      this.gyrusAudio!.srcObject = this.recorderSteam;
    }
    this.recorder = new RecordRTC(stream as MediaStream, {
      type: "audio",
      mimeType: "audio/wav",
    });
    return this.recorder;
  }
}
